import { ConfigurationRepositoryWorkspacesService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryWorkspacesService'
import type { ConfigurableServer } from '@festina-life/core'
import {
  type QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'

import {
  allConciseWorkspacesKeyPrefix,
  fetchWorkspaceOperationsKey,
} from '../keys/configuration'

type DeleteWorkspaceInputArguments = {
  name: string
  server: ConfigurableServer
  shouldSkipCacheInvalidation?: boolean
}

export const invalidateWorkspaceCache = async ({
  queryClient,
  name,
  server,
}: {
  queryClient: QueryClient
} & Omit<DeleteWorkspaceInputArguments, 'shouldSkipCacheInvalidation'>) => {
  await queryClient.invalidateQueries({
    queryKey: [allConciseWorkspacesKeyPrefix],
  })
  await queryClient.invalidateQueries({
    queryKey: fetchWorkspaceOperationsKey({
      workspaceName: name,
      server,
    }),
  })
}

export const useDeleteConciseWorkspace = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ name, server }: DeleteWorkspaceInputArguments) => {
      await ConfigurationRepositoryWorkspacesService.workspaceServiceDeleteDeleteWorkspace(
        { workspaceName: name, componentName: server.toLocaleLowerCase() },
      )
    },
    onSuccess: async (_, { shouldSkipCacheInvalidation, ...rest }) => {
      if (!shouldSkipCacheInvalidation) {
        await invalidateWorkspaceCache({ queryClient, ...rest })
      }
    },
  })
}
